import _extends from "@babel/runtime/helpers/esm/extends";

var _actions;

// Vendor Libs
import cloneDeep from 'lodash.clonedeep';
import now from 'lodash.now'; // Action Types

import { actionTypes } from '../action-types';
var initialState = {
  fetching: false,
  fetched: false,
  error: null,
  params: {},
  response: {}
};

var getInitialState = function getInitialState(serviceKey, serviceConfig, params) {
  if (params === void 0) {
    params = {};
  }

  var _serviceConfig$servic = serviceConfig[serviceKey];
  _serviceConfig$servic = _serviceConfig$servic === void 0 ? {} : _serviceConfig$servic;
  var _serviceConfig$servic2 = _serviceConfig$servic.params,
      serviceParams = _serviceConfig$servic2 === void 0 ? {} : _serviceConfig$servic2;
  return _extends({}, cloneDeep(initialState), {
    params: _extends({}, cloneDeep(initialState.params), {}, serviceParams, {}, params)
  });
};

var actions = (_actions = {}, _actions[actionTypes.SERVICE_REGISTER] = function (state, _ref, serviceConfig) {
  var _extends2;

  var _ref$payload = _ref.payload,
      _ref$payload$params = _ref$payload.params,
      params = _ref$payload$params === void 0 ? {} : _ref$payload$params,
      serviceKey = _ref$payload.serviceKey;
  return !state[serviceKey] ? _extends({}, cloneDeep(state), (_extends2 = {}, _extends2[serviceKey] = getInitialState(serviceKey, serviceConfig, params), _extends2)) : state;
}, _actions[actionTypes.SERVICE_UNREGISTER] = function (state, _ref2) {
  var _extends3;

  var serviceKey = _ref2.payload.serviceKey;
  return _extends({}, cloneDeep(state), (_extends3 = {}, _extends3[serviceKey] = undefined, _extends3));
}, _actions[actionTypes.SERVICE_PENDING] = function (state, _ref3) {
  var _extends4;

  var serviceKey = _ref3.meta.serviceKey;
  return _extends({}, cloneDeep(state), (_extends4 = {}, _extends4[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    fetching: true,
    fetched: false,
    error: null
  }), _extends4));
}, _actions[actionTypes.SERVICE_FULFILLED] = function (state, _ref4) {
  var _extends5;

  var _ref4$payload = _ref4.payload,
      response = _ref4$payload.response,
      serviceKey = _ref4$payload.serviceKey;
  return _extends({}, cloneDeep(state), (_extends5 = {}, _extends5[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    error: null,
    fetching: false,
    fetched: true,
    lastUpdated: now(),
    response: response
  }), _extends5));
}, _actions[actionTypes.SERVICE_REJECTED] = function (state, _ref5) {
  var _extends6;

  var _ref5$payload = _ref5.payload,
      error = _ref5$payload.error,
      serviceKey = _ref5$payload.serviceKey;
  return _extends({}, cloneDeep(state), (_extends6 = {}, _extends6[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    fetching: false,
    error: error,
    response: {}
  }), _extends6));
}, _actions[actionTypes.SERVICE_SET_PARAM_VALUE] = function (state, _ref6) {
  var _extends7, _extends8;

  var _ref6$payload = _ref6.payload,
      serviceKey = _ref6$payload.serviceKey,
      paramName = _ref6$payload.paramName,
      value = _ref6$payload.value;
  return _extends({}, cloneDeep(state), (_extends8 = {}, _extends8[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    params: _extends({}, cloneDeep(state[serviceKey].params), (_extends7 = {}, _extends7[paramName] = value !== '' ? value : undefined, _extends7))
  }), _extends8));
}, _actions[actionTypes.SERVICE_SET_PARAM_VALUES] = function (state, _ref7) {
  var _extends9;

  var _ref7$payload = _ref7.payload,
      serviceKey = _ref7$payload.serviceKey,
      params = _ref7$payload.params,
      resetValues = _ref7$payload.resetValues;
  return _extends({}, cloneDeep(state), (_extends9 = {}, _extends9[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    params: resetValues ? params : _extends({}, cloneDeep(state[serviceKey].params), {}, params)
  }), _extends9));
}, _actions[actionTypes.SERVICE_CLEAR_PARAM_VALUE] = function (state, _ref8) {
  var _extends10, _extends11;

  var _ref8$payload = _ref8.payload,
      serviceKey = _ref8$payload.serviceKey,
      paramName = _ref8$payload.paramName;
  return _extends({}, cloneDeep(state), (_extends11 = {}, _extends11[serviceKey] = _extends({}, cloneDeep(state[serviceKey]), {
    params: _extends({}, cloneDeep(state[serviceKey].params), (_extends10 = {}, _extends10[paramName] = undefined, _extends10))
  }), _extends11));
}, _actions[actionTypes.SERVICE_RESET] = function (state, _ref9, serviceConfig) {
  var _extends12;

  var serviceKey = _ref9.payload.serviceKey;
  return serviceKey ? _extends({}, cloneDeep(state), (_extends12 = {}, _extends12[serviceKey] = getInitialState(serviceKey, serviceConfig), _extends12)) : {};
}, _actions);
export var getServiceReducer = function getServiceReducer(_temp) {
  var _ref10 = _temp === void 0 ? {} : _temp,
      serviceConfig = _ref10.serviceConfig;

  return function (state, action) {
    if (state === void 0) {
      state = {};
    }

    return actions[action.type] ? actions[action.type](state, action, serviceConfig) : state;
  };
};